import { useTranslation } from 'react-i18next'

import { Product } from '@shared/generated'
import { cn } from '@shared/lib/cn'
import { formatOrderWeightTranslation } from '@shared/uttils/weightHelpers'

import styles from './styles.module.scss'

interface InStockProps {
  data: Product;
}

export default function InStock (props: InStockProps) {
  const { t: tp } = useTranslation('product')
  const { t: tc } = useTranslation('common')
  const { data } = props

  if (!data.stock?.amount) return null

  return (
    <div
      className={cn(styles.amount, 'amount-global', {
        [styles['amount--red']]: data.stock?.amount && data.stock?.amount <= 5,
      })}
    >
      {tp('in_stock')}{' '}
      <span>
        {data?.isWeightProduct
          ? formatOrderWeightTranslation(data?.stock.amount || 0, tp)
          : `${data.stock?.amount} ${tc('weight.pc')}`}
      </span>
    </div>
  )
}
